module.exports = __webpack_public_path__ + "acc91afe021987c2491da56d8a6fbb42.png";